var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { TreeReportsItem } from "./treeReportsItem";
import { useGetAORDataTreeQuery } from "@/store/api";
export var TreeReportsList = function (_a) {
    var module = _a.module, _b = _a.level, level = _b === void 0 ? 0 : _b, _c = _a.isOpen, isOpen = _c === void 0 ? false : _c, _d = _a.updateAORModuleList, updateAORModuleList = _d === void 0 ? function () { } : _d;
    var _e = useState([]), dataTree = _e[0], setDataTree = _e[1];
    var _f = useState(false), anyOpen = _f[0], setAnyOpen = _f[1];
    var _g = useGetAORDataTreeQuery({ module: module }), AORresponse = _g.data, isLoading = _g.isLoading, isError = _g.isError, isFetching = _g.isFetching;
    useEffect(function () {
        var _a, _b;
        if ((_a = AORresponse === null || AORresponse === void 0 ? void 0 : AORresponse.data) === null || _a === void 0 ? void 0 : _a.results) {
            setDataTree((_b = AORresponse === null || AORresponse === void 0 ? void 0 : AORresponse.data) === null || _b === void 0 ? void 0 : _b.results);
        }
    }, [AORresponse]);
    var updateReportsModule = function (module) {
        updateAORModuleList(module);
    };
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "relative flex flex-col items-stretch w-full pb-2" }, { children: dataTree && (_jsx("ul", { children: Object.values(dataTree).map(function (item, index) { return (_jsx("li", __assign({ className: "flex flex-col items-stretch" }, { children: _jsx(TreeReportsItem, { level: level, item: item, index: index, isOpen: isOpen, anyOpen: anyOpen, setAnyOpen: setAnyOpen, updateAORModule: updateReportsModule }) }), item.id)); }) })) })) }));
};
